import {
    ARRIVAL_DEPARTURE_OVERLAP_TIME,
    ARRIVAL_DEPARTURE_THRESHOLD,
    LESS_THAN_THIRTY,
    LESS_THAN_ZERO
} from '@/src/constants/srp'

export function checkingFlightsValidTimings(sectorTime: number) {
    if (sectorTime < ARRIVAL_DEPARTURE_OVERLAP_TIME) {
        return LESS_THAN_ZERO
    } else if (sectorTime < ARRIVAL_DEPARTURE_THRESHOLD) {
        return LESS_THAN_THIRTY
    }
    return true
}
